import React, { useState, useEffect, useRef } from 'react';

const AnnouncementBox = () => {
    const listRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false); // Track hover state

    useEffect(() => {
        const interval = setInterval(() => {
            if (listRef.current && !isHovered) { // Only scroll if not hovered
                const scrollHeight = listRef.current.scrollHeight;
                const clientHeight = listRef.current.clientHeight;

                // Check if the bottom of the list is reached
                if (listRef.current.scrollTop + clientHeight >= scrollHeight) {
                    listRef.current.scrollTop = 0; // Reset scroll to the top when it reaches the bottom
                } else {
                    listRef.current.scrollTop += 1; // Scroll down gradually
                }
            }
        }, 30); // Speed of the scrolling (lower is faster)

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [isHovered]); // Re-r) => clearInterval(interval); // Cleanup interval on component unmount


    return (
        <>
            <div className="announcement-box rounded shadow-sm p-3 pt-0 mb-5 bg-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)} >
                <div className="announcement-title  text-white text-center p-2 font-weight-bold" style={{ backgroundColor: "#1d3243 " }}>
                    Announcements
                </div>
                <div
                    className="announcement-list"
                    style={{ maxHeight: '200px', overflow: 'hidden', position: 'relative' }}
                    ref={listRef}
                >
                    <ul style={{ listStyleType: "disc" }} className=" p-2 m-0">
                           
                        
                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/02_04_2026_Events/GuruPranam_30Mar2026.jpeg" target="_blank">
                                Guru Pranamam 2k26 on 30th March, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/02_04_2026_Events/sayonara_31Mar2026.jpeg" target="_blank">
                                SAYONARA 2K26 - Farewell Celebrations on 31st March, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/02_04_2026_Events/CS_1APR2026.jpeg" target="_blank">
                                Tech Talk on "What lies ahead in AI for Cybersecurity" on 1st April, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/02_04_2026_Events/iCompass_1APR2026.jpeg" target="_blank">
                                MOU with iCompaas on 1st April, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/02_04_2026_Events/Venture_1APR2026.jpeg" target="_blank">
                                VENTURE LAUNCH BOOTCAMP on 1st & 2nd April, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/ICSCSP-2026-June-19-20.jpeg" target="_blank">
                                9th International Conference on Soft Computing and Signal Processing (ICSCSP-2026), to be held on June 19�20, 2026.
                            </a>
                        </li>

                    </ul>
                </div>
                <div className="announcement-footer  text-center" style={{ backgroundColor: "#1d3243 " }}>
                    <a href="/Home/Events" className="d-block p-2 font-weight-bold text-white text-decoration-none">
                        View All
                    </a>
                </div >
            </div >
        </>
    );
};

export default AnnouncementBox;
